var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internal-management-section"},_vm._l((_vm.sections),function(section,i){return _c('div',{key:i,staticClass:"my-4"},[_c('app-title',{attrs:{"text":section.name}}),_vm._v(" "),_vm._l((_vm.getItemsBySection(section.slug)),function(item){return _c('app-internal-management-section',{key:item.id,attrs:{"item":item}})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }